import * as types from './LanguageActionTypes';

const initialState = {
    language: 'nl',
};

export default function Language(state = initialState, action) {
    switch (action.type) {
        case types.SET_LANGUAGE:
            if (action.payload !== state.language) {
                return Object.assign({}, state, { language: action.payload });
            }
            return state;
        default:
            return state;
    }
}
